import media from "./media";
import mediaImage from "./mediaImage";
import mediaVideo from "./mediaVideo";
import mediaAudio from "./mediaAudio";

import reference from "./reference";
import localizedString from "./localizedString";

import geopoint from "./geopoint";

import color from "./color";

export default {
    "media": media,
    "image": mediaImage,
    "video": mediaVideo,
    "audio": mediaAudio,
    "reference": reference,
    "localizedString": localizedString,
    "geopoint": geopoint,
    "color": color
};